import { Component, OnInit } from '@angular/core';
import {
  getConnection,
  hideSpinner,
  showSpinner,
} from 'src/app/core/services/functions.service';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ReportesService } from '../reportes.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';

@Component({
  selector: 'app-reportes',
  templateUrl: './reportes.component.html',
  styleUrls: ['./reportes.component.scss'],
})
export class ReportesComponent implements OnInit {
  STEP = 1;

  tipoReportes: any[] = [
    {
      key: 'report_cam_plan',
      value: 'REPORTE DE CAMBIOS DE PLAN REALIZADO'
    }
  ]

  registros = 0;
  url = '';

  public formCriterios = this.formBuilder.group({
    tipo: ["report_cam_plan", [Validators.required]],
    fechaInicio: [new Date(), [Validators.required]],
    fechaFin: [new Date(), [Validators.required]],
  })

  constructor(
    private formBuilder: FormBuilder,
    private reportesService: ReportesService,
    private notificationHelper: NotificationHelper
  ) { }

  ngOnInit(): void { }

  async generarReporte() {
    this.STEP = 1;
    const formValues = this.formCriterios.value
    if (!this.formCriterios.get("fechaInicio")?.valid) { return this.notificationHelper.warningMessage("Ingrese el Codigo del Proveedor") }
    if (!this.formCriterios.get("fechaFin")?.valid) { return this.notificationHelper.warningMessage("Ingrese el Codigo del Proveedor") }

    const fecha_ini = formValues.fechaInicio;
    const fecha_fin = formValues.fechaFin;
    try {
      showSpinner('Generando Reporte...')
      const res = await this.reportesService.camPlanAplicados(getConnection(), fecha_ini, fecha_fin);
      if(!res.success) {
        this.notificationHelper.warningMessage('Ocurrio un error al momento de generar el reporte.');
      }
      this.registros = res.data.registros;
      this.url = res.data.url;
      this.STEP = 2;
      this.moverScroll("step2");
    } catch (error) {
      this.notificationHelper.warningMessage('Ocurrio un error al momento de generar el reporte.');
      hideSpinner();
    }
    hideSpinner();
  }

  async moverScroll(tag: string) {
    setTimeout(function () {
        const docu = document.getElementById(tag);
        if (docu) {
            docu.scrollIntoView({
                behavior: "smooth",
                block: "start",
                inline: "nearest"
            });
        }
    }, 200);
  }


}
